






























































































































































import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import {SelectBox, SelectMarket, StrategyOfPriceOpt, TaskInfoCalc} from '@/interfaces/global-data';
import {GetTaskInfo, PackagePromoConfig, TaskData, TaskInfoFilterType} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import Http from '@/mixins/http';
import {HttpExecutor} from '@/mixins/HttpExecutor';
import {FormatNumber} from '@/numberFormatter';
import {Component, Mixins} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import CSelect from '@/components/UI/CoefficientSelect.vue';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import LocalData from '../mixins/local-data';
import Toast from '../mixins/toast';
import CollapseCard from "@/components/UI/CollapseCard.vue"
import Card from '@/components/UI/Card.vue';

@Component({
    components: {
      MultiSelect,
      MarketSelect,
      vSelect,
      CollapseCard,
      Card,
      CSelect,
      SwitchWithLabel,
    },
      methods: {
          replaceTxtToNumber(value) {
              if (value == null) {
                  return null
              } else {
                  return value.replace(/[^\d]/g, '').substring(0, 2);
              }
          },
      },
  })
  export default class PackagePromo extends Mixins(LocalData, Toast, Http) {
    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('selectOptions.common.all') as string}];
    taskInfo: TaskInfoCalc = {
      storeFormatOptions: [],
      storeRegionOptions: [],
      buyerSegmentOptions: [],
      categoryOptions: [],
      clusterOptions: [],
      groupsOfProduct: [],
      subcategories: [],
      subcategoriesDefault: [],
      psegemnts: [],
    };
    errors = [];
    tableKey = 1;
    searchable: boolean = true;

    tasksLoading: boolean = false;
    showMainFilters: boolean = true;
    tasksCount: number = 0;
    showBookmarks: boolean = true;
    private dropDownOpen = false;
    // tslint:disable-next-line: ban-types
    private onDropdownClosed: Function | null = null;
    private httpExecutor = new HttpExecutor();

    numberFormatter = (v: any): string => FormatNumber.format(v);

    mounted() {
      if (this.$packagePromo.selectMarket.id !== -1) {
        const self = this;
        (this.$refs.groupSelectedRef as any).toggleLoading(true);
        (this.$refs.updateRegionsRef as any).toggleLoading(true);
        (this.$refs.updateSeasonsRef as any).toggleLoading(true);
        (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(true);
        (this.$refs.formatSelectedRef as any).toggleLoading(true);
        (this.$refs.clasterSelectedRef as any).toggleLoading(true);
        (this.$refs.groupOfProductRef as any).toggleLoading(true);
        (this.$refs.subcategoriesRef as any).toggleLoading(true);
            (this.$refs.productSegmentsRef as any).toggleLoading(true);
        this.getCategoryInfo();
        self.getRegionInfo();
        self.getFormatInfo();
        self.getBuyerSegment();
        self.getClusterInfo();
        self.loadProductsGroup();
        self.loadProductsSubcategories();
        self.loadProductSegments();
      }

      EventBus.$on('calc', this.onCalcEventReceived);
    }

    beforeDestroy() {
        EventBus.$off('calc', this.onCalcEventReceived);
    }

    onCalcEventReceived(data: TaskData) {
        if (this.showCalcProgress(data.status)) {
        }
    }

    resetData(type: TaskInfoFilterType) {
      switch (type) {
        case TaskInfoFilterType.group:
          this.$packagePromo.categoriesOfProduct = [];
                this.$packagePromo.subcategories = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromo.formatSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromo.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromo.clusterSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromo.productSegments = this.defaultIntSelectBox.map(i => i.value);
          this.taskInfo.categoryOptions = [];
          this.taskInfo.subcategories = [];
          this.taskInfo.psegemnts = [];
          this.taskInfo.storeFormatOptions = [];
          this.taskInfo.storeRegionOptions = [];
          this.taskInfo.clusterOptions = [];
          this.getCategoryInfo(null);
          this.loadProductsSubcategories();
          this.loadProductSegments();
          this.getFormatInfo();
          this.getRegionInfo();
          this.getClusterInfo();
          break;
        case TaskInfoFilterType.category:
                this.$packagePromo.subcategories = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromo.formatSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromo.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromo.clusterSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromo.productSegments = this.defaultIntSelectBox.map(i => i.value);
          this.taskInfo.subcategories = [];
          this.taskInfo.psegemnts = [];
          this.taskInfo.storeFormatOptions = [];
          this.taskInfo.storeRegionOptions = [];
          this.taskInfo.clusterOptions = [];
          this.loadProductsSubcategories();
          this.loadProductSegments();
          this.getFormatInfo();
          this.getRegionInfo();
          this.getClusterInfo();
          break;
        case TaskInfoFilterType.subcategory:
                this.$packagePromo.formatSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromo.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromo.clusterSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromo.productSegments = this.defaultIntSelectBox.map(i => i.value);
          this.taskInfo.psegemnts = [];
          this.taskInfo.storeFormatOptions = [];
          this.taskInfo.storeRegionOptions = [];
          this.taskInfo.clusterOptions = [];
          this.loadProductSegments();
          this.getFormatInfo();
          this.getRegionInfo();
          this.getClusterInfo();
          break;
        case TaskInfoFilterType.p_segemnt:
                this.$packagePromo.formatSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromo.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromo.clusterSelected = this.defaultIntSelectBox.map(i => i.value);
          this.taskInfo.storeFormatOptions = [];
          this.taskInfo.storeRegionOptions = [];
          this.taskInfo.clusterOptions = [];
          this.getFormatInfo();
          this.getRegionInfo();
          this.getClusterInfo();
          break;
        case TaskInfoFilterType.format:
          this.$packagePromo.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
          this.$packagePromo.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
          this.taskInfo.storeRegionOptions = [];
          this.taskInfo.clusterOptions = [];
          this.loadProductSegments();
          this.getRegionInfo();
          this.getClusterInfo();
          break;
        case TaskInfoFilterType.region:
          this.$packagePromo.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
          this.taskInfo.clusterOptions = [];
          this.loadProductSegments();
          this.getClusterInfo();
          break;
      }
    }

    updateProductGroup(groupOfProduct: number[]) {
      if (groupOfProduct.length > 0 && !LocalData.compareTwoArrays(groupOfProduct, this.$packagePromo.groupsOfProduct)) {
        this.$packagePromo.groupsOfProduct = groupOfProduct;
        this.savePackagePromo();
        this.resetData(TaskInfoFilterType.group);
      } else if (this.$packagePromo.groupsOfProduct[0] === 0) {
        this.$packagePromo.groupsOfProduct = this.defaultIntSelectBox.map((i) => i.value);
      }
    }

    updateProductCategory(categories: number[]) {
      if (categories.length > 0 && !LocalData.compareTwoArrays(categories, this.$packagePromo.categoriesOfProduct)) {
        this.$packagePromo.categoriesOfProduct = categories;
        this.resetData(TaskInfoFilterType.category);
        this.savePackagePromo();
      } else if (this.$packagePromo.categoriesOfProduct[0] === 0) {
            this.$packagePromo.categoriesOfProduct = this.defaultIntSelectBox.map(i => i.value);
        }
    }

    updateProductSegment(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packagePromo.productSegments)) {
            this.$packagePromo.productSegments = list;
            this.saveEvents();
            this.resetData(TaskInfoFilterType.p_segemnt);
        } else if (this.$packagePromo.productSegments[0] === 0) {
            this.$packagePromo.productSegments = this.defaultIntSelectBox.map(i => i.value);
      }
    }

    updateFormats(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packagePromo.formatSelected)) {
            this.$packagePromo.formatSelected = list;
            this.resetData(TaskInfoFilterType.format);
            this.savePackagePromo();
        } else if (this.$packagePromo.formatSelected[0] === 0) {
            this.$packagePromo.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateRegions(list: number[]) {
      if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packagePromo.regionSelected)) {
        this.$packagePromo.regionSelected = list;
        this.resetData(TaskInfoFilterType.region);
        this.savePackagePromo();
      } else if (this.$packagePromo.regionSelected[0] === 0) {
          this.$packagePromo.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
      }
    }

      updateClusters(list: number[]) {
          if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packagePromo.clusterSelected)) {
              this.$packagePromo.clusterSelected = list;
              this.resetData(TaskInfoFilterType.cluster);
              this.savePackagePromo();
          } else if (this.$packagePromo.clusterSelected[0] === 0) {
              this.$packagePromo.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
          }
      }

    updateBuyerSegments(list: number[]) {
      if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packagePromo.buyerSegmentsList)) {
        this.$packagePromo.buyerSegmentsList = list;
        this.savePackagePromo();
      } else if (this.$packagePromo.buyerSegmentsList[0] === 0) {
          this.$packagePromo.buyerSegmentsList = this.defaultIntSelectBox.map((i) => i.value);
      }
    }

    updateSubcategories(list: number[]) {
      if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packagePromo.subcategories)) {
        this.$packagePromo.subcategories = list;
        this.savePackagePromo();
        this.resetData(TaskInfoFilterType.subcategory);
      } else if (this.$packagePromo.subcategories[0] === 0) {
          this.$packagePromo.subcategories = this.defaultIntSelectBox.map((i) => i.value);
      }
    }

    updateSeasons(list: number[]) {
      if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packagePromo.seasonSelected)) {
        this.$packagePromo.seasonSelected = list;
        this.savePackagePromo();
      } else if (this.$packagePromo.seasonSelected[0] === 0) {
          this.$packagePromo.seasonSelected = this.defaultIntSelectBox.map((i) => i.value);
      }
    }

    updateSelectMarket(market: SelectMarket) {
      if (this.$packagePromo.selectMarket == null || this.$packagePromo.selectMarket.id !== market.id) {
        this.resetPackagePromoData();
        this.$packagePromo.selectMarket = market;
        this.initTask();
        this.savePackagePromo();
        this.$packagePromo.selectCoefficent = {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: this.$t('selectOptions.priceOptStrategy.maxGrossMargin') as string}
      }
    }

    showCalcProgress(status: string): boolean {
      return (status === 'WriteToFileComplete'
        || status === 'EmptyData'
        || status === 'ExecutionException'
        || status.includes('Error'));
    }

    selectData(): [number[], number[], number[], number[]] {
      const selectSeasons: number[] = (this.$packagePromo.seasonSelected.length === 0 || (this.$packagePromo.seasonSelected.length === 1 && this.$packagePromo.seasonSelected[0] === 0))
        ? []
        // tslint:disable-next-line: no-non-null-assertion
        : LocalData.filterNumberArrays(this.$packagePromo.seasonSelected)!!;
      const selectRegions: number[] = (this.$packagePromo.regionSelected.length === 0 || (this.$packagePromo.regionSelected.length && this.$packagePromo.regionSelected[0] === 0))
        ? []
        // tslint:disable-next-line: no-non-null-assertion
        : LocalData.filterNumberArrays(this.$packagePromo.regionSelected)!!;
      const selectBuyerSegment: number[] = (this.$packagePromo.buyerSegmentsList.length === 0 || (this.$packagePromo.buyerSegmentsList.length && this.$packagePromo.buyerSegmentsList[0] === 0))
        ? []
        // tslint:disable-next-line: no-non-null-assertion
        : LocalData.filterNumberArrays(this.$packagePromo.buyerSegmentsList)!!;
      const selectFormats: number[] = (this.$packagePromo.formatSelected.length === 0 || (this.$packagePromo.formatSelected.length && this.$packagePromo.formatSelected[0] === 0))
              ? []
              // tslint:disable-next-line: no-non-null-assertion
              : LocalData.filterNumberArrays(this.$packagePromo.formatSelected)!!;
      return [selectSeasons, selectRegions, selectBuyerSegment, selectFormats];
    }

    initTask() {
      if (this.$packagePromo.selectMarket.id === -1) {
        return;
      }
      (this.$refs.updateRegionsRef as any).toggleLoading(true);
      (this.$refs.updateSeasonsRef as any).toggleLoading(true);
      (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(true);
      (this.$refs.formatSelectedRef as any).toggleLoading(true);
      (this.$refs.groupSelectedRef as any).toggleLoading(true);
      (this.$refs.clasterSelectedRef as any).toggleLoading(true);
      (this.$refs.groupOfProductRef as any).toggleLoading(true);
      (this.$refs.subcategoriesRef as any).toggleLoading(true);
        (this.$refs.productSegmentsRef as any).toggleLoading(true);

      this.$packagePromo.categoriesOfProduct = [];
      this.$packagePromo.clusterSelected = [];
      this.$packagePromo.formatSelected = [];
      this.$packagePromo.groupsOfProduct = [];
      this.$packagePromo.subcategories = [];
        this.$packagePromo.productSegments = [];
      this.taskInfo.storeFormatOptions = [];
      this.taskInfo.storeRegionOptions = [];
      this.taskInfo.buyerSegmentOptions = [];
      this.taskInfo.categoryOptions = [];
      this.taskInfo.clusterOptions = [];
      this.taskInfo.psegemnts = [];
      this.taskInfo.subcategories = [];
      this.taskInfo.groupsOfProduct = [{value: null, label: this.$t('selectOptions.common.all') as string}];
      const self = this;
      this.getCategoryInfo(() => {
        self.loadProductsGroup();
        self.getRegionInfo();
        self.getFormatInfo();
        self.getBuyerSegment();
        self.getClusterInfo();
        self.loadProductsSubcategories();
        self.loadProductSegments();
      });
    }

    loadProductsGroup() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
        .then((data) => {
          const filterData = data.data;
          setTimeout(() => {
            (this.$refs.groupOfProductRef as any).toggleLoading(false);
          }, 250);
          this.taskInfo.groupsOfProduct = filterData.groups.map((i) => {
            return {value: i.id, label: i.name}
          });
          this.taskInfo.groupsOfProduct.unshift({value: 0, label: this.$t('selectOptions.common.all') as string});
        })
        .catch((e) => {
        })
    }

    loadProductsSubcategories() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
        .then((data) => {
          const filterData = data.data;
          setTimeout(() => {
            (this.$refs.subcategoriesRef as any).toggleLoading(false);
          }, 250);
          this.taskInfo.subcategories = filterData.subcategories.map((i) => {
            return {value: i.id, label: i.name}
          });
          this.taskInfo.subcategories.unshift({value: 0, label: this.$t('selectOptions.common.all') as string})
        })
        .catch((e) => {
        })
    }

    getCategoryInfo(cb: any = null) {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
        .then((data) => {
          const filterData = data.data;
          setTimeout(() => {
            (this.$refs.groupSelectedRef as any).toggleLoading(false);
            (this.$refs.updateSeasonsRef as any).toggleLoading(false);
          }, 250);
          this.taskInfo.categoryOptions = filterData.categories.map((i) => {
            return {value: i.id, label: i.name}
          });
          this.taskInfo.categoryOptions.unshift();
          if (typeof cb === 'function') {
            cb();
          }
        })
        .catch((e) => {
        })
    }

    getRegionInfo() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
        .then((data) => {
          const filterData = data.data;
          setTimeout(() => {
            (this.$refs.updateRegionsRef as any).toggleLoading(false);

          }, 500);

          this.taskInfo.storeRegionOptions = filterData.storeRegion.map((i) => {
            return {value: i.id, label: i.name};
          });
        })
        .catch((e) => {
        });
    }

    getFormatInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
                .then((data) => {
                    const filterData = data.data;
                    setTimeout(() => {
                        (this.$refs.formatSelectedRef as any).toggleLoading(false);
                    }, 500);
                    this.taskInfo.storeFormatOptions = filterData.storeFormat.map((i) => {
                        return {value: i.id, label: i.name};
                    });

                })
                .catch((e) => {
                });
    }

    getBuyerSegment() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.buyer))
        .then((data) => {
          const filterData = data.data;
          setTimeout(() => {
            (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(false);
          }, 500);

          this.taskInfo.buyerSegmentOptions = filterData.buyerSegments.map((i) => {
            return {value: i.id, label: i.name};
          });

        })
        .catch((e) => {
        });
    }

    getClusterInfo() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
        .then((data) => {
          const filterData = data.data;
          setTimeout(() => {
            (this.$refs.clasterSelectedRef as any).toggleLoading(false);
          }, 500);

          this.taskInfo.clusterOptions = filterData.storeCluster.map((i) => {
            return {value: i.id, label: i.name};
          });
        })
        .catch((e) => {
        });
    }

    loadProductSegments() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.p_segemnt))
            .then(data => {
          const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.productSegmentsRef as any).toggleLoading(false);
                }, 250);
                this.taskInfo.psegemnts = filterData.psegments.map(i => {
              return {
                  label: i.name,
                        value: i.id
                    };
          });
                this.taskInfo.psegemnts.unshift({ value: 0, label: this.$t('selectOptions.common.all') as string });
        })
            .catch(e => {});
    }

    packagePromoCalc() {
      if (this.$packagePromo.selectMarket.id <= 0) {
        this.showError(this.$t('packagePromo.errors.companyNotSelected') as string);
        return;
      }
      const filters = this.getPackagePromoFilter();
      if (LocalData.filterNumberArrays(filters.groupsOfProduct, true) == null
        && LocalData.filterNumberArrays(filters.categories, true) == null) {
        (this.$refs.confirmPackagePromo as any).show();
        return;
      } else {
        this.savePackagePromo();
        this.showInfo(this.$t('packagePromo.messages.calcStarted') as string);
        this.httpAddPackagePromoTask(filters)
          .then((r) => {
              this.$log.debug('Create task', r.data);
            },
          )
          .catch((e) => {
            this.showError(this.$t('packagePromo.errors.startCalcError') as string);
          });
      }
    }

    calcButtonState(): boolean {
      if (this.$packagePromo.selectMarket != null) {
        const state = this.calculationDayValidate;
        return !state;

      }
      return true;
    }

    confirmCalc() {
      const filters = this.getPackagePromoFilter();
      this.savePackagePromo();
      this.showInfo(this.$t('packagePromo.messages.calcStarted2') as string);
      this.httpAddPackagePromoTask(filters)
              .then((r) => {
                        this.$log.debug('Create task', r.data);
                      },
              )
              .catch((e) => {
                this.showError(this.$t('packagePromo.errors.startCalcError2') as string);
              });
    }

    clearConfirmData() {
      this.tasksLoading = false;
    }

    onMultiSelectToggle(open: boolean) {
        this.dropDownOpen = open;
        if (!open) {
            if (this.onDropdownClosed != null) {
                this.onDropdownClosed.apply(open);
                this.onDropdownClosed = null;
            }
        }
    }

    loadTasksCount() {
      this.tasksLoading = true;
      this.httpExecutor.executeHttp(this.httpGetPackageTasksCount, this.getPackagePromoFilter())
              .then((r) => {
                if (!r.ignore) {
                  this.tasksLoading = false;
                  this.tasksCount = r.response.data.count;
                }
              })
              .catch((e) => {
                this.showError(this.$t('packagePromo.errors.startCalcError3') as string);
              });
    }

    private getTaskInfo(filterType: TaskInfoFilterType): GetTaskInfo {
      const [, selectRegions, , selectFormats] = this.selectData();
      return {
        type: filterType,
        tradingId: this.$packagePromo.selectMarket.id,
        categories: LocalData.filterNumberArrays(this.$packagePromo.categoriesOfProduct),
        groups: LocalData.filterNumberArrays(this.$packagePromo.groupsOfProduct),
        subcategory: LocalData.filterNumberArrays(this.$packagePromo.subcategories, true),
            productSegments: LocalData.filterNumberArrays(this.$packagePromo.productSegments),
        segments: null,
        storeFormat: selectFormats,
        storeCluster: this.$packagePromo.clusterSelected,
        storeRegion: selectRegions,
        byReports: false,
      }
    }

    private getPackagePromoFilter(): PackagePromoConfig {
      // tslint:disable-next-line: no-non-null-assertion
      let groups = LocalData.filterNumberArrays(this.$packagePromo.groupsOfProduct)!!;
      // Если не выбрали ни одной группы и оставили опцию "Все"
      if (groups.length === 0) {
          groups = this.taskInfo.groupsOfProduct.map((group) => {
              // tslint:disable-next-line: no-non-null-assertion
              return group.value!!
          });
          // Удаляем из массива опцию "Все"
          groups.splice(0, 1)
      }
      const [selectSeasons, selectRegions, selectBuyerSegment, selectFormats] = this.selectData();
      const selectClusters: number[] = (this.$packagePromo.clusterSelected.length === 0 || (this.$packagePromo.clusterSelected.length && this.$packagePromo.clusterSelected[0] === 0))
// tslint:disable-next-line: no-non-null-assertion
              ? [] : LocalData.filterNumberArrays(this.$packagePromo.clusterSelected)!!;
      const sendReportToFtp = this.$packagePromo.sendReportToFtp;
      return {
        coefficientK1: this.$packagePromo.selectCoefficent.value.k1,
        coefficientK2: this.$packagePromo.selectCoefficent.value.k2,
// tslint:disable-next-line: no-non-null-assertion
        categories: LocalData.filterNumberArrays(this.$packagePromo.categoriesOfProduct)!!,
        productSegments: LocalData.filterNumberArrays(this.$packagePromo.productSegments)!!,
        storeCluster: selectClusters,
        seasonValues: selectSeasons,
        buyerSegments: selectBuyerSegment,
        storeRegionValues: selectRegions,
        storeFormat: selectFormats,
        tradingId: this.$packagePromo.selectMarket.id,
        calculationDay: +this.$packagePromo.calculationDay,
// tslint:disable-next-line: no-non-null-assertion
        groupsOfProduct: groups,
// tslint:disable-next-line: no-non-null-assertion
        priceOpt: this.$packagePromo.selectCoefficent.value.enum!,
        subcategories: LocalData.filterNumberArrays(this.$packagePromo.subcategories),
        separateSubcategories: this.$packagePromo.separateSubcategories,
        separateClusters: this.$packagePromo.separateClusters,
        packageCalc: true,
        categoryStrategy: this.$packagePromo.categoryStrategy.value,
        sendReportToFtp,
        makeGeneralReport: this.$packagePromo.makeGeneralReport,
          isFixPricePromo: this.$packagePromo.isFixPricePromo,
        calcWithBatchNumber: false,
        thompsonSampling: false,
        applyOmnichannel: false,
        sendGeneralReportNotification: localStorage.getItem('sendGeneratedReportNotification') === 'true',
        useSkuRotation: this.$promo.useSkuRotation,
        useFixedPrices: true,
      };
    }

    get saveState(): boolean {
// tslint:disable-next-line: no-non-null-assertion
      const filteredGroups = LocalData.filterNumberArrays(this.$packagePromo.groupsOfProduct)!!.length;
// tslint:disable-next-line: no-non-null-assertion
      const filteredCategories = LocalData.filterNumberArrays(this.$packagePromo.categoriesOfProduct)!!.length;
      return (filteredGroups === 1 && filteredCategories === 1) || (filteredGroups === 1 && filteredCategories === 0) || (filteredGroups === 0 && filteredCategories === 1);
    }

    get calculationDayValidate(): boolean {
      return this.$packagePromo.calculationDay > 0;
    }

    get calcButt(): boolean {
      return this.calcButtonState();
    }

    get isGroupsSelected(): boolean {
        const groups = LocalData.filterNumberArrays(this.$packagePromo.groupsOfProduct);
        return groups != null && groups.length > 0;
    }

      get isCategoriesSelected(): boolean {
          const categories = LocalData.filterNumberArrays(this.$packagePromo.categoriesOfProduct);
          return categories != null && categories.length > 0;
      }

    get isSubcategorySelected(): boolean {
        const subcategories = LocalData.filterNumberArrays(this.$packagePromo.subcategories);
        return subcategories != null && subcategories.length!! > 0;
    }

      get isFormatSelected(): boolean {
          const formats = LocalData.filterNumberArrays(this.$packagePromo.formatSelected);
          return formats != null && formats.length > 0;
      }


      get isRegionsSelected(): boolean {
          const regions = LocalData.filterNumberArrays(this.$packagePromo.regionSelected);
          return regions != null && regions.length > 0;
      }

  }
